

     // <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 78 78" fill="none"><path d="M44.7958 40.241C48.4972 37.9846 50.8889 33.5282 50.8889 29.4103C50.8889 23.5436 46.0486 17 39.5 17C32.9514 17 28.1111 23.5436 28.1111 29.4103C28.1111 33.5282 30.5028 37.9846 34.2042 40.241C25.4347 42.5538 19 50.5077 19 59.8718C19 60.4923 19.5125 61 20.1389 61H58.8611C59.4875 61 60 60.4923 60 59.8718C60 50.5077 53.5653 42.5538 44.7958 40.241ZM30.3889 29.4103C30.3889 23.6 35.2292 19.2564 39.5 19.2564C43.7708 19.2564 48.6111 23.6 48.6111 29.4103C48.6111 35.2205 43.7708 39.5641 39.5 39.5641C35.2292 39.5641 30.3889 35.2205 30.3889 29.4103ZM21.3347 58.7436C21.9042 49.3231 29.8764 41.8205 39.5 41.8205C49.1236 41.8205 57.0958 49.3231 57.6653 58.7436H21.3347Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78ZM39 76C59.4345 76 76 59.4345 76 39C76 18.5655 59.4345 2 39 2C18.5655 2 2 18.5655 2 39C2 59.4345 18.5655 76 39 76Z" fill="black"></path></svg>
 if (window.location.href == "https://signtradesupplies.co.uk/account?a=cd_my-profile") {
    
   let customerDetails = globalFields.shopAndCustomer();
    let email = customerDetails.email;
      let Shop = customerDetails.Shop;
      //check the customer have trade account or not
      let checkUrl = `https://wholesale.apptiv.in/api/isApproved?Shop=${Shop}&email=${email}`;
  async function statusCheck (){
    // try{
    //     const response = await fetch(checkUrl, {
    //     method: "GET",
    //     mode: "cors",
    //     redirect: 'follow'         
    //   });
    //    let resData = await response.json();
    //     if(!response.ok) { 
    //       throw new Error(resData.message);
    //     }
    //     if(resData.exist){
    //        jQuery('.tradeAnncode').remove();
    //        jQuery('#tradeCustomerAnncode').remove();
    //     } 
    //     else{
    //       jQuery('#tradeCustomerAnncode').remove();
    // jQuery('.cd_active_ul  li:first').after(`<li id="cd_my-profile tradeCustomerAnncode" class="cd_menu-child tradeAnncode" onclick="TradeRequestAnncode()">
      // <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 63 60">
      // <image width="63" height="60" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA8CAYAAADRy2JxAAAEjElEQVRoQ+2bTUhVQRTHR1o8SJAMBCFFUQjKQvuAoE0gSO2EilpKgtuy3PvQvVltC8FlUUG7IBDdKAVBIX0QvFAyECTSFwRCUvf/ah73jTNzzv2ae+/LAcHHmztzfvd8zrn3Nfz2hvhPR8MefB1r/ufbd2J75UvlD6N58IIodLZX/jdqfmeznKlbsu9AUyB5yguLYvVmUQBejtYbI6Lj9kT1cw08gNcmp0R5frHmokC7JjQZ2uqamRZN585adwAsoAHvHyr4Ls1/ujgsvj97npD40ZeF9k9/+6hdSCpuY/ahUK0W4G3jY0K1nqrmcceWTw5ElzDBFUzwgC0Nj2oV1zJ0xTP1yV3gNZpfv3tfrN4qJih69KV18FAaLFYGNP8u+3t7xNG5J1rwGvi1iSnx1fP3LA/4fV/pZVVEuCg0rgvOFHju4A95fttWHKvAw1IRnHXgsJDjr19UU5pJoVWft2kei7VeHyEXS9JqGvt6BLTJAT/8dIbMCmzNH5l7zFosSXi5NhWbAI5ChjNIzdvSC2eDOOdszD7ygvK41tSxjy6X2/bPDTyi+vv+S7GBs8w+C5qnwDmRXWcBmdc8ovnyqQFtHgcQN7LnDt5WuUnw7pk7lQCHWr48vyR2tv4eyGANqO5y6/OoOBHdTUPmfVNpDvgu7+aEzvNp+TyV0vxgprmU7Jn0eSrAocxFBSdPaaYCLXfw8HOkNH8Twm+2AFIruLqB/+wdVFDMmAY6MShm/KMu4Ck/R1SH1tXhBF6mkx8LS+LX5lZFBvgf/poHz0eq/3EeRz439Q5h7idKr7RncyfwVOrBTUD6ofKrqjkAoyGh9t3882wHFifwEMbWOZHCosDomJ5gWwLVSKEOLM7gJSCn2UkJjbWgbaxlMnc1rekCoXN4CEFpTJaZpj4aldZwPed8ngq81NyH/svWGhpuAAj5pEROpm4ex3JsSnBS5MB0qRsAQWABshUVh7lTN9EJPNcC5A0odLRHiu6p5Hmrbf8LXhwLOOgVK7YqzlTMmPZPzedVgdBLR/QOO1T34KyTGXgISxVDNiB/b54DnnrA0wnJqQPU68L24jKleUBxcrgKH/b5QObgAYbDypvuMyzrDRrk/ItmEh4CUsdUzAkT5HIBDyHx3N/UmcH3YYJcbuBt5m87p7P8xZuUWbOXAKb0F1XrWB+Fla4X4Ky8pbSke/LCOa5S69piivoyg7qW09Y1Slo0KOXQNSMpWP/3VDDFm1tIn6bhFB5CIPUhBkTVOgWOvfC0xtZScw4vtR9F6xxwTi/AObxsVqK5EfStSm7dYHrvLlWfl5vjBqQNDlmcaz5IQAsS3DCXq3G5bi7guT6ue8XUdrNJeFyMF//U5mNYDQa9LilwltljEvIlHkKg9+Zq4HHY+r0H1pcTwpi6X36W5l0BB90nqI8HjvZBBXI1Pyo42+xdAXH3iQO8Bj5q15UreNR5cYHXwOODrLujCpjU9XGC74JHt6V0bTRzv69BNYgc3jJ0NVRlaFKG9tdVaAxsr6wlpcBA6xY620Rj77FYoaUAez8qDKSKOpr8B0bXpon91epwAAAAAElFTkSuQmCC"></image>
      // </svg>
    //   <span  id="formpopupopns">Trade + Member</span>    
    // </li>`); 
    //     }
    //   } 
    // catch(e){
         
    //   }

    
 let customerMemberOrNot = globalFields.customerTagsCheck();
 let TradeCustomer = false; 
  let originalCartObjPrice = []
  if (customerMemberOrNot == 'Trade+') {
   jQuery('.tradeAnncode').remove();
  jQuery('#tradeCustomerAnncode').remove();
  }
  else{
          jQuery('#tradeCustomerAnncode').remove();
    jQuery('.cd_active_ul  li:first').after(`<li id="cd_my-profile tradeCustomerAnncode" class="cd_menu-child tradeAnncode" onclick="TradeRequestAnncode()">
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 63 60">
      <image width="63" height="60" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA8CAYAAADRy2JxAAAEjElEQVRoQ+2bTUhVQRTHR1o8SJAMBCFFUQjKQvuAoE0gSO2EilpKgtuy3PvQvVltC8FlUUG7IBDdKAVBIX0QvFAyECTSFwRCUvf/ah73jTNzzv2ae+/LAcHHmztzfvd8zrn3Nfz2hvhPR8MefB1r/ufbd2J75UvlD6N58IIodLZX/jdqfmeznKlbsu9AUyB5yguLYvVmUQBejtYbI6Lj9kT1cw08gNcmp0R5frHmokC7JjQZ2uqamRZN585adwAsoAHvHyr4Ls1/ujgsvj97npD40ZeF9k9/+6hdSCpuY/ahUK0W4G3jY0K1nqrmcceWTw5ElzDBFUzwgC0Nj2oV1zJ0xTP1yV3gNZpfv3tfrN4qJih69KV18FAaLFYGNP8u+3t7xNG5J1rwGvi1iSnx1fP3LA/4fV/pZVVEuCg0rgvOFHju4A95fttWHKvAw1IRnHXgsJDjr19UU5pJoVWft2kei7VeHyEXS9JqGvt6BLTJAT/8dIbMCmzNH5l7zFosSXi5NhWbAI5ChjNIzdvSC2eDOOdszD7ygvK41tSxjy6X2/bPDTyi+vv+S7GBs8w+C5qnwDmRXWcBmdc8ovnyqQFtHgcQN7LnDt5WuUnw7pk7lQCHWr48vyR2tv4eyGANqO5y6/OoOBHdTUPmfVNpDvgu7+aEzvNp+TyV0vxgprmU7Jn0eSrAocxFBSdPaaYCLXfw8HOkNH8Twm+2AFIruLqB/+wdVFDMmAY6MShm/KMu4Ck/R1SH1tXhBF6mkx8LS+LX5lZFBvgf/poHz0eq/3EeRz439Q5h7idKr7RncyfwVOrBTUD6ofKrqjkAoyGh9t3882wHFifwEMbWOZHCosDomJ5gWwLVSKEOLM7gJSCn2UkJjbWgbaxlMnc1rekCoXN4CEFpTJaZpj4aldZwPed8ngq81NyH/svWGhpuAAj5pEROpm4ex3JsSnBS5MB0qRsAQWABshUVh7lTN9EJPNcC5A0odLRHiu6p5Hmrbf8LXhwLOOgVK7YqzlTMmPZPzedVgdBLR/QOO1T34KyTGXgISxVDNiB/b54DnnrA0wnJqQPU68L24jKleUBxcrgKH/b5QObgAYbDypvuMyzrDRrk/ItmEh4CUsdUzAkT5HIBDyHx3N/UmcH3YYJcbuBt5m87p7P8xZuUWbOXAKb0F1XrWB+Fla4X4Ky8pbSke/LCOa5S69piivoyg7qW09Y1Slo0KOXQNSMpWP/3VDDFm1tIn6bhFB5CIPUhBkTVOgWOvfC0xtZScw4vtR9F6xxwTi/AObxsVqK5EfStSm7dYHrvLlWfl5vjBqQNDlmcaz5IQAsS3DCXq3G5bi7guT6ue8XUdrNJeFyMF//U5mNYDQa9LilwltljEvIlHkKg9+Zq4HHY+r0H1pcTwpi6X36W5l0BB90nqI8HjvZBBXI1Pyo42+xdAXH3iQO8Bj5q15UreNR5cYHXwOODrLujCpjU9XGC74JHt6V0bTRzv69BNYgc3jJ0NVRlaFKG9tdVaAxsr6wlpcBA6xY620Rj77FYoaUAez8qDKSKOpr8B0bXpon91epwAAAAAElFTkSuQmCC"></image>
      </svg>
      <span  id="formpopupopns">Register for Trade+</span>    
    </li>`); 
        }
    
  } 
      statusCheck();//for hide the trade member buttom from dashboard
}

 


function validatePhoneNumber() {
      var phoneNumber = document.getElementById('Phone').value.trim();
      var phoneRegex = /^(\+44|0)\d{10}$/;
      if (phoneRegex.test(phoneNumber)) {
        document.getElementById('Phone').setCustomValidity(''); // Clear any previous validation message
      } else {
        document.getElementById('Phone').setCustomValidity('Please enter a valid phone number starting with +44 or 0, followed by 10 digits.');
      }
    }

// 
  // document.addEventListener('DOMContentLoaded', function() {
  //   // Get the element with the ID "formpopupopns"
  //   var formpopupopns = document.getElementById('formpopupopns');
    
  //    var loader = document.getElementById('loader');
  //   // check the customer is exist or not
  //   // if ( formpopupopns  ) {
  //      formpopupopns.addEventListener('click', async function() {
  //     showLoader() 
  //     let customerDetails = globalFields.shopAndCustomer();
  //     let firstName = customerDetails.firstName;
  //     let lastName = customerDetails.lastName;
  //     let email = customerDetails.email;
  //     let Shop = customerDetails.Shop;
  //     //check the customer have trade account or not
  //     let checkUrl = `https://wholesale.apptiv.in/api/check?Shop=${Shop}&email=${email}`;
  //     try{
  //       const response = await fetch(checkUrl, {
  //       method: "GET",
  //       mode: "cors",
  //       redirect: 'follow'         
  //     });
  //      let resData = await response.json();
  //       if(!response.ok) {
  //       hideLoader();
  //         throw new Error(resData.message);
  //       }
  //       if(resData.exist){
  //       hideLoader();
  //          showPopupMessage("You already have an account.", 'success');
  //          ;
  //       }else {
  //         hideLoader();
  //            FromPopUp();
  //       }
     
  //     } catch(e){
  //       hideLoader();
  //       showPopupMessage("something went wrong", 'error');
  //     }
      
  //   });
  // });
    // }
   
// Function to toggle the form popup visibility and body overflow
    

// //form open when customer is not exis
// function FromPopUp(){
//       let customerDetails = globalFields.shopAndCustomer();
//       let firstName = customerDetails.firstName;
//       let lastName = customerDetails.lastName;
//       // let phone = customerDetails.phone;
//       let email = customerDetails.email;
//       let Shop = customerDetails.Shop;
//       var formPopup = document.getElementById('formPopup');
//       var body = document.body;
//     if (formPopup.style.display === 'none' || formPopup.style.display === '') {
//       formPopup.style.display = 'flex';
//       body.style.overflow = 'hidden';
//     document.getElementById('anncodeemail').value= email
//     document.getElementById('lastName').value= lastName
//     document.getElementById('firstName').value= firstName
//     }
//   }
//
// $("#ac-trade-submit").click(function(){
//     var formPopup = document.getElementById('formPopup');
//     var body = document.body;
//      body.style.overflow = 'visible';
//     formPopup.style.display === 'none'
//   })
//form submit
async function TradeFormSubmit (event,isNewformData,HubSpotformData){
    showLoader()
  

        let customerDetails = globalFields.shopAndCustomer();
        let Shop = customerDetails.Shop;
        var formData = isNewformData
        formData.Shop = Shop
     
    try {
      const queryString = new URLSearchParams(formData).toString();
      const url = `https://wholesale.apptiv.in/api/signUp`;
      // const url = `https://jsl80hpb-8081.inc1.devtunnels.ms/api/signUp`;
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body : JSON.stringify(formData)
      });
     
      if (!response.ok) {
        hideLoader();
        throw new Error(`HTTP error! Status: ${response.status}`);
      }else{
       hideLoader();
      const data = await response.json();
      // await sendDataFromHubSpot(HubSpotformData)
      await sendDataFromHubSpot(isNewformData)
        if(data.exist){
          showPopupMessage("Your request has pending!", 'success');
        } else {
           showPopupMessage("Trade account request has been sent for the approval!", 'success');
           window.location.href = `https://signtradesupplies.co.uk/account?a=cd_my-profile`;
      }
    }
    } catch (error) {
      hideLoader();
      showPopupMessage("Something went wrong", 'error');
 
    }
  }
//
// function toggleFormPopup() {
//     var formPopup = document.getElementById('formPopup');
//     formPopup.style.display = (formPopup.style.display === 'none' || formPopup.style.display === '') ? 'block' : 'none';
//   }

// async function sendDataFromHubSpot(formData) {
//   try {
    
//     // Add HubSpot context
//     const hs_context = {
//       source: "forms-embed-static",
//       sourceName: "forms-embed",
//       sourceVersion: "1.0",
//       referrer: document.referrer,
//       pageUrl: window.location.href,
//       pageTitle: document.title,
//       userAgent: navigator.userAgent,
//       locale: "en"
//     };

//     formData.append("hs_context", JSON.stringify(hs_context));

//     const response = await fetch(
//       "https://forms.hubspot.com/uploads/form/v2/145132345/9aa285a6-ed0b-457f-b376-10daa2ee1244",
//       {
//         method: "POST",
//         body: formData
//       }
//     );

//     const result = await response.text();

//   } catch (err) {
//       hideLoader();
//       showPopupMessage("Something went wrong", 'error');
//     console.error("❌ HubSpot error:", err);
//   }
// }


async function sendDataFromHubSpot(formData) {
  try {
    // Transform data to correct field names
    const data = {
      "firstname": formData.firstname,
      "lastname": formData.lastname,
      "email": formData.email,
      "website": formData.website,
      "linkedin": formData.linkedin,
      "turnover": formData.turnover,
      "team_size___contact_copy": formData.team_size,
      "business_premises___contact_copy": formData.business_premises,
      "services_offered___contact_copy": Array.isArray(formData.services) ? formData.services.join(';') : formData.services,
      "product_interest___contact_copy": Array.isArray(formData.products) ? formData.products.join(';') : formData.products,
      "equipment": Array.isArray(formData.equipment) ? formData.equipment.join(';') : formData.equipment,
    };

    // Convert to fields array
    const fields = Object.entries(data).map(([name, value]) => ({
      name: name,
      value: value
    }));

    const payload = {
      fields: fields,
      context: {
        pageUri: window.location.href,
        pageName: document.title,
        hutk: document.cookie.match(/hubspotutk=([^;]*)/)?.[1]
      }
    };

    const response = await fetch(
      "https://api.hsforms.com/submissions/v3/integration/submit/145132345/9aa285a6-ed0b-457f-b376-10daa2ee1244",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();
    
    if (response.ok) {
      console.log("✅ Success:", result);
      return result;
    } else {
      console.error("❌ Error:", result);
      throw new Error(result.message);
    }

  } catch (err) {
    console.error("❌ HubSpot error:", err);
    throw err;
  }
}


//popup message 
function showPopupMessage(message, type) {
    var popupContainer = document.getElementById('popup-container');
    var successPopup = document.getElementById('success-popup');
    var errorPopup = document.getElementById('error-popup');

    if (type === 'success') {
        successPopup.textContent = message;
        successPopup.style.display = 'block';
        errorPopup.style.display = 'none';
    } else if (type === 'error') {
        errorPopup.textContent = message;
        errorPopup.style.display = 'block';
        successPopup.style.display = 'none';
    }

    popupContainer.style.display = 'block';

    setTimeout(function () {
        popupContainer.style.display = 'none';
        successPopup.style.display = 'none';
        errorPopup.style.display = 'none';
    }, 2000); // Hide the message after 5 seconds (adjust the time as needed)
}
//show the loader
function showLoader() {
 
        var loader = document.getElementById('loader');
        loader.style.display = 'block';
    }
//hide the loadder
function hideLoader() {
        var loader = document.getElementById('loader');
        loader.style.display = 'none';
    }


  const TradeRequestAnncode = ()=>{
  // window.location.href = "https://signtradesupplies.co.uk/pages/trade-request"
  window.location.href = "https://signtradesupplies.co.uk/pages/trade-plus-account"
}
let val =jQuery('.cd_active_ul  a:first .cd_sidebarlink').html()
if(val && val.includes('Trade+')){

jQuery('.cd_active_ul a:first ').each(function() {
    var $div = jQuery(this).find('.cd_fontawesome_circle');
    $div.html(`<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 78 78">
      <image width="78" height="78" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA8CAYAAADRy2JxAAAEjElEQVRoQ+2bTUhVQRTHR1o8SJAMBCFFUQjKQvuAoE0gSO2EilpKgtuy3PvQvVltC8FlUUG7IBDdKAVBIX0QvFAyECTSFwRCUvf/ah73jTNzzv2ae+/LAcHHmztzfvd8zrn3Nfz2hvhPR8MefB1r/ufbd2J75UvlD6N58IIodLZX/jdqfmeznKlbsu9AUyB5yguLYvVmUQBejtYbI6Lj9kT1cw08gNcmp0R5frHmokC7JjQZ2uqamRZN585adwAsoAHvHyr4Ls1/ujgsvj97npD40ZeF9k9/+6hdSCpuY/ahUK0W4G3jY0K1nqrmcceWTw5ElzDBFUzwgC0Nj2oV1zJ0xTP1yV3gNZpfv3tfrN4qJih69KV18FAaLFYGNP8u+3t7xNG5J1rwGvi1iSnx1fP3LA/4fV/pZVVEuCg0rgvOFHju4A95fttWHKvAw1IRnHXgsJDjr19UU5pJoVWft2kei7VeHyEXS9JqGvt6BLTJAT/8dIbMCmzNH5l7zFosSXi5NhWbAI5ChjNIzdvSC2eDOOdszD7ygvK41tSxjy6X2/bPDTyi+vv+S7GBs8w+C5qnwDmRXWcBmdc8ovnyqQFtHgcQN7LnDt5WuUnw7pk7lQCHWr48vyR2tv4eyGANqO5y6/OoOBHdTUPmfVNpDvgu7+aEzvNp+TyV0vxgprmU7Jn0eSrAocxFBSdPaaYCLXfw8HOkNH8Twm+2AFIruLqB/+wdVFDMmAY6MShm/KMu4Ck/R1SH1tXhBF6mkx8LS+LX5lZFBvgf/poHz0eq/3EeRz439Q5h7idKr7RncyfwVOrBTUD6ofKrqjkAoyGh9t3882wHFifwEMbWOZHCosDomJ5gWwLVSKEOLM7gJSCn2UkJjbWgbaxlMnc1rekCoXN4CEFpTJaZpj4aldZwPed8ngq81NyH/svWGhpuAAj5pEROpm4ex3JsSnBS5MB0qRsAQWABshUVh7lTN9EJPNcC5A0odLRHiu6p5Hmrbf8LXhwLOOgVK7YqzlTMmPZPzedVgdBLR/QOO1T34KyTGXgISxVDNiB/b54DnnrA0wnJqQPU68L24jKleUBxcrgKH/b5QObgAYbDypvuMyzrDRrk/ItmEh4CUsdUzAkT5HIBDyHx3N/UmcH3YYJcbuBt5m87p7P8xZuUWbOXAKb0F1XrWB+Fla4X4Ky8pbSke/LCOa5S69piivoyg7qW09Y1Slo0KOXQNSMpWP/3VDDFm1tIn6bhFB5CIPUhBkTVOgWOvfC0xtZScw4vtR9F6xxwTi/AObxsVqK5EfStSm7dYHrvLlWfl5vjBqQNDlmcaz5IQAsS3DCXq3G5bi7guT6ue8XUdrNJeFyMF//U5mNYDQa9LilwltljEvIlHkKg9+Zq4HHY+r0H1pcTwpi6X36W5l0BB90nqI8HjvZBBXI1Pyo42+xdAXH3iQO8Bj5q15UreNR5cYHXwOODrLujCpjU9XGC74JHt6V0bTRzv69BNYgc3jJ0NVRlaFKG9tdVaAxsr6wlpcBA6xY620Rj77FYoaUAez8qDKSKOpr8B0bXpon91epwAAAAAElFTkSuQmCC"></image>
      </svg>`);
});
jQuery('.cd_active_ul a:first .cd_sidebarlink').css({
    'margin-right': '5px',
    'color': 'red'
});
}
 